// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3DM-K","title":"Images90_title__3BCHO","images":"Images90_images__AokPl"};